import React from 'react';

//axios
import axios from 'axios';
import axiosUrl from '../../axios/url';


// 비밀번호 초기화 하기
export default function PasswordReset(param) {
    const [username, setUsername] = React.useState('');

    async function getPasswordReset(){
        
        var sendData = {
            username: username
        }
        await axios.put(axiosUrl.passwordReset, sendData)
        .then( response => {
            alert(username + '님의 비밀번호가 초기화 되었습니다.');
        })
        .catch(function (e) {
            alert(e.response.data.error.message);
        });

    }

    function trim(stringToTrim) {
        return stringToTrim.replace(/^\s+|\s+$/g,"");
    }

    // 이메일 validation
    function validateEmailAddress(email) {
        var expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
        return expression.test(String(email).toLowerCase());
   }
    
    // handler
    function handleUsername(e){  setUsername(trim(e.target.value)); }

    function savePassword() {
        if(username === '') {alert('사용자 이름을 입력하세요.'); return;}
        if(!validateEmailAddress(username)) { alert('사용자 이름은 이메일 형식입니다.'); return;}
        if(!window.confirm(username + '님의 비밀번호를 초기화하시겠습니까?')) return;

        getPasswordReset();
    }

    return(
    <div className="register-box">
        <div className="register-logo">
            <a href="/"><b>myHealth</b>CMS</a>
        </div>

        <div className="card">
            <div className="card-body register-card-body">
            <p className="login-box-msg">비밀번호 초기화</p>

                <div className="input-group mb-3">
                    <input type="email" className="form-control" placeholder="사용자 이름" onChange={handleUsername} />
                    <div className="input-group-append">
                        <div className="input-group-text">
                        <span className="fas fa-envelope"></span>
                        </div>
                    </div>
                </div>
                
                <div className="row d-block">
                    <div className="col-4 float-right">
                        <button type="submit" className="btn btn-primary btn-block btn-flat" onClick={savePassword}>변경하기</button>
                    </div>
                </div>

            </div>
        </div>
    </div>
      
    );
}